import { render } from "./Oidc.vue?vue&type=template&id=79877eb7"
import script from "./Oidc.vue?vue&type=script&lang=js"
export * from "./Oidc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/pages/Oidc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79877eb7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79877eb7', __exports__)) {
    api.reload('79877eb7', __exports__)
  }
  
  module.hot.accept("./Oidc.vue?vue&type=template&id=79877eb7", () => {
    api.rerender('79877eb7', render)
  })

}


export default __exports__